const Adress = {
    frontendUrl: 'http:localhost:3000',
  };
  
  export default Adress;